import React from "react";
import { ThemeProvider } from "@material-ui/styles";
import Avatar from "@material-ui/core/Avatar";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import theme from "../../../../themes/defaultTheme";
//import Default_Avatar from "../../../../../Assets/Images/Defaults/default_avatar.jpg";
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  small: {
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  large: {
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
}));

const A_Avatar = (props) => {
  const classes = useStyles();
  return (
    <ThemeProvider theme={theme}>
      <div className={classes.root}>
        {props.size === "small" && (
          <Avatar alt={props.alt} src={props.src} className={classes.small}>
            {" "}
            {props.text}
          </Avatar>
        )}
        {props.size === "large" && (
          <Avatar alt={props.alt} src={props.src} className={classes.large}>
            {" "}
            {props.text}
          </Avatar>
        )}
        {props.size === "normal" && (
          <Avatar alt={props.alt} src={props.src}>
            {" "}
            {props.text}
          </Avatar>
        )}
      </div>
    </ThemeProvider>
  );
};
A_Avatar.defaultProps = {
  alt: "Alt text",
  text: "UN",
  src: null,
  size: "large",
  variant: "rounded",
};
export default A_Avatar;
